// Local notifications for sync success and sync clash (on-device, not FCM).
import { LocalNotifications } from "@capacitor/local-notifications";
import { Capacitor } from "@capacitor/core";

let permissionAsked = false;
const CHANNEL_ID = "lion_sync";

export const ensureNotificationPermission = async () => {
  if (!Capacitor.isNativePlatform()) return false;
  if (permissionAsked) return true;
  try {
    const perm = await LocalNotifications.checkPermissions();
    if (perm.display !== "granted") {
      await LocalNotifications.requestPermissions();
    }
    try {
      await LocalNotifications.createChannel({
        id: CHANNEL_ID,
        name: "Sync",
        description: "Offline sync status",
        importance: 4,
      });
    } catch (_e) {
      // channel may already exist / iOS
    }
    permissionAsked = true;
    return true;
  } catch (_e) {
    return false;
  }
};

const notify = async ({ id, title, body, extra }) => {
  if (!Capacitor.isNativePlatform()) return;
  await ensureNotificationPermission();
  await LocalNotifications.schedule({
    notifications: [
      {
        id: id || Math.floor(Math.random() * 100000) + 1,
        title,
        body,
        channelId: CHANNEL_ID,
        extra: extra || {},
      },
    ],
  });
};

export const notifySyncSuccess = async (count) => {
  await notify({
    id: 9001,
    title: "Lion sync complete",
    body: `Synced ${count} change${count === 1 ? "" : "s"}.`,
    extra: { type: "sync_success" },
  });
};

export const notifySyncClash = async () => {
  await notify({
    id: 9002,
    title: "Sync conflict",
    body: "Tap to choose phone or server version.",
    extra: { type: "sync_clash" },
  });
};

export const onNotificationAction = async (handler) => {
  if (!Capacitor.isNativePlatform()) return () => {};
  const sub = await LocalNotifications.addListener("localNotificationActionPerformed", (event) => {
    handler(event?.notification?.extra || {});
  });
  return () => sub.remove();
};
